module.exports = __webpack_public_path__ + "static/media/tag.bd837e2c.svg";